import {PayMethod} from "../types/types";

export const payMethodCode = (method: PayMethod) => {
    switch (method) {
        case "CARD":
            return '100000000000'
        case "TRANSFER":
            return '010000000000'
        case "VIRTUAL_ACCOUNT":
            return '001000000000'
    }
}
